import { render, staticRenderFns } from "./co-payment-methods.vue?vue&type=template&id=71d133ac&scoped=true&"
import script from "./co-payment-methods.vue?vue&type=script&lang=js&"
export * from "./co-payment-methods.vue?vue&type=script&lang=js&"
import style0 from "./co-payment-methods.vue?vue&type=style&index=0&id=71d133ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d133ac",
  null
  
)

export default component.exports